// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__coH7f","col":"styles_col__1td7S"};